(function() {
    angular.module("app").factory("noticeService", noticeService)

    noticeService.$inject = [
        "$rootScope",
        "$http"
    ]

    function noticeService(
        $rootScope,
        $http
    ) {

        const service = {}

        service.formatContentForDisplay = (content) => {

            content = "<p>" + content.replaceAll("\n", "</p><p>")

            if (content.slice(content.length - 3, content.length) === "<p>") {
                content = content.slice(0, content.length - 3)
            } else {
                content = content + "</p>"
            }

            content = content.replaceAll("<p></p>", "<p>&nbsp;</p>")

            return content.replaceAll("<p>", "<p class='noticeContentParagraph'>")

        }

        service.getNotices = (manage, search, success, failure) => {

            const _success = (response) => {
                if (success) {
                    success(response.data)
                }
            }

            const _failure = (response) => {
                console.error(response)
                if (failure) {
                    failure(response.data)
                }
            }

            let query = ""

            if ($rootScope.can("SystemNoticeRead") && manage) {
                query = "?manage=true"
            }

            if (search !== undefined && search !== "") {
                if (query === "") {
                    query = "?search=" + search
                } else {
                    query += "&search=" + search
                }
            }

            $http({
                method: "GET",
                url: $rootScope.config.apiUrl + "/notices" + query
            }).then(_success, _failure)
        }

        service.getNotice = (noticeID, success, failure) => {

            const _success = (response) => {
                if (success) {
                    success(response.data)
                }
            }

            const _failure = (response) => {
                console.error(response)
                if (failure) {
                    failure(response.data)
                }
            }

            $http({
                method: "GET",
                url: $rootScope.config.apiUrl + "/notices/" + noticeID
            }).then(_success, _failure)

        }

        service.getLatestUnreadNotice = (userID) => {

            const success = (response) => {
                if (response && response.data && response.data.id && response.data.title && response.data.content && response.data.publish_on) {
                    $rootScope.displayNotice = response.data
                }
            }

            const failure = (response) => {
                console.error(response)
            }

            return $http({
                method: "GET",
                url:    $rootScope.config.apiUrl + "/users/" + userID + "/latest_notice",
            }).then(success, failure)
        }

        service.emailNotice = (noticeID, success, failure) => {

            const _success = (response) => {
                if (success) {
                    success(response.data)
                }
            }

            const _failure = (response) => {
                console.error(response)
                if (failure) {
                    failure(response.data)
                }
            }

            $http({
                method: "GET",
                url: $rootScope.config.apiUrl + "/notices/" + noticeID + "/email"
            }).then(_success, _failure)

        }

        service.markNotice = (noticeID, read, success, failure) => {

            const _success = (response) => {
                if (success) {
                    success(response.data)
                }
            }

            const _failure = (response) => {
                console.error(response)
                if (failure) {
                    failure(response.data)
                }
            }

            $http({
                method: "PUT",
                url: $rootScope.config.apiUrl + "/notices/" + noticeID + "/mark",
                data: {
                    read: read
                }
            }).then(_success, _failure)

        }

        service.createNotice = (notice, success, failure) => {

            const _success = (response) => {
                if (success) {
                    success(response.data)
                }
            }

            const _failure = (response) => {
                console.error(response)
                if (failure) {
                    failure(response.data)
                }
            }

            $http({
                method: "POST",
                url: $rootScope.config.apiUrl + "/notices/",
                data: notice
            }).then(_success, _failure)

        }

        service.updateNotice = (notice, success, failure) => {

            const _success = (response) => {
                if (success) {
                    success(response.data)
                }
            }

            const _failure = (response) => {
                console.error(response)
                if (failure) {
                    failure(response.data)
                }
            }

            $http({
                method: "PUT",
                url: $rootScope.config.apiUrl + "/notices/" + notice.id,
                data: {
                    notice: {
                        id:         notice.id,
                        title:      notice.title,
                        content:    notice.content,
                        publish_on: notice.publish_on
                    }
                }
            }).then(_success, _failure)

        }

        service.deleteNotice = (noticeID, success, failure) => {

            const _success = (response) => {
                if (success) {
                    success(response.data)
                }
            }

            const _failure = (response) => {
                console.error(response)
                if (failure) {
                    failure(response.data)
                }
            }

            $http({
                method: "DELETE",
                url: $rootScope.config.apiUrl + "/notices/" + noticeID
            }).then(_success, _failure)

        }

        return service

    }
})()
